import { render, staticRenderFns } from "./detailsRecipient.vue?vue&type=template&id=7b8c0a0c"
import script from "./detailsRecipient.vue?vue&type=script&lang=js"
export * from "./detailsRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports